import React, { useState, useEffect, useRef } from 'react';
import { Popper, Fade, Paper } from '@mui/material';
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export function TooltipWrapper(props) {
    const {
        tooltipText,
        children,
        placement = "top", // top, right, bottom, or left
        displayContent, // Deprecated; included for error reporting
    } = props;

    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const scrollTimeoutRef = useRef(null);

    // Close tooltip on scroll to prevent blocking page scroll
    useEffect(() => {
        if (open) {
            const handleScroll = () => {
                setOpen(false);
                if (scrollTimeoutRef.current) {
                    clearTimeout(scrollTimeoutRef.current);
                }
                scrollTimeoutRef.current = setTimeout(() => {
                    setAnchorEl(null);
                }, 200);
            };

            // Listen to scroll events on window and all scrollable containers
            window.addEventListener('scroll', handleScroll, true); // Use capture phase
            window.addEventListener('wheel', handleScroll, { passive: true });
            window.addEventListener('touchmove', handleScroll, { passive: true });

            return () => {
                window.removeEventListener('scroll', handleScroll, true);
                window.removeEventListener('wheel', handleScroll);
                window.removeEventListener('touchmove', handleScroll);
                if (scrollTimeoutRef.current) {
                    clearTimeout(scrollTimeoutRef.current);
                }
            };
        }
    }, [open]);

    if (!tooltipText) {
        return (
            <div className="text-mpLRed">
                TooltipWrapper missing props: {!tooltipText && 'tooltipText'}
            </div>
        );
    }
    // Remove this warning once all code has been fully refactored
    if (displayContent) {
        return (
            <div className="text-mpLRed">
                Tooltip has deprecated prop displayContent.
            </div>
        );
    }

    const handleHoverOn = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };
    const handleHoverOff = () => {
        setOpen(false);
        // Clear anchorEl after a short delay to prevent flickering
        setTimeout(() => {
            setAnchorEl(null);
        }, 200);
    }

    return (
        <>
            <span
                onMouseEnter={(e) => handleHoverOn(e)}
                onMouseLeave={() => handleHoverOff()}
                style={{ display: 'inline-block', cursor: 'help' }}
            >
                {children}
            </span>
            {anchorEl && (
                <Popper
                    placement={placement}
                    open={open}
                    anchorEl={anchorEl}
                    transition
                    disablePortal={false}
                    modifiers={[
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 8],
                            },
                        },
                        {
                            name: 'preventOverflow',
                            enabled: true,
                            options: {
                                padding: 8,
                                boundary: 'viewport', // Keep tooltip within viewport
                            },
                        },
                        {
                            name: 'flip',
                            enabled: true,
                            options: {
                                fallbackPlacements: ['top', 'bottom', 'left', 'right'],
                            },
                        },
                    ]}
                    style={{ 
                        zIndex: 9999,
                        pointerEvents: 'none' // Allow scroll events to pass through when not hovering tooltip
                    }}
                >
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps} timeout={200}>
                            <Paper
                                onMouseEnter={(e) => {
                                    e.stopPropagation();
                                    handleHoverOn(e);
                                }}
                                onMouseLeave={(e) => {
                                    e.stopPropagation();
                                    handleHoverOff();
                                }}
                                onWheel={(e) => {
                                    // Allow scrolling within tooltip content
                                    e.stopPropagation();
                                }}
                                style={{ 
                                    maxHeight: '400px', 
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                    padding: '8px',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    maxWidth: '400px',
                                    pointerEvents: 'auto', // Re-enable pointer events on tooltip content
                                    // Smooth scrolling for better UX
                                    scrollBehavior: 'smooth',
                                    // Custom scrollbar styling for better visibility
                                    scrollbarWidth: 'thin',
                                }}
                                elevation={3}
                            >
                                <div style={{ padding: '4px' }}>{tooltipText}</div>
                            </Paper>
                        </Fade>
                    )}
                </Popper>
            )}
        </>
    );
}